<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <hk-btn-upload-modal :options-format="formatsFile" :url="urlUpload" @success="importSuccess" @failure="importFailure" />
                  <FilterDate :value-date=filters.date @filter-change="onDateFilterChange" @clean-filter-date="onCleanFilterDate"/>
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <filter-abonado :filter-abonado-selected="filterAbonadoSelected" @filter-change="onFilterAbonadoChange"></filter-abonado>
                  <SgaRegisteredFilter :filter-sga-registered="filters.sga_registered" @sga-registered-filter-change="onFilterSgaRegisteredChange"/>
                  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-type="csv" @click="onDownloadExcel">
                    <span class="btn-inner--icon">
                      <i class="fa-solid fa-file-download me-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_returnListTableHeader_button_export_return') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_returnListTableHeader_button_reload_return')" @change="getOrdersBack"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!devolucionesData"
            ref="genericTable"
            :items="devolucionesData?.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="devolucion">
              <td style="width: 5rem">
                <div class="d-flex align-items-center">
                  <a style="cursor:pointer" class="mx-3" :title="$t('key_orderBackList_viewFiles')" data-bs-toggle="modal" data-bs-target="#uploadFolder" @click="loadResource(devolucion)">
                    <i v-if="devolucion.with_resource && devolucion.with_resource == true" class="fa-solid fa-folder-plus text-warning"></i>
                    <i v-else class="fa-solid fa-folder-open text-warning"></i>
                  </a>
                  <FileModalSelector
                    data-bs-backdrop="static"
                    :resources='ordersBackResource'
                    :entity-id='entityId'
                    :entity-number='entityNumber'
                    :errors='ordersBackErrorResource'
                    :url='urlUploadResource'
                    @success-upload='uploadedResource'
                    @remove-item='removeResource'
                    @close-modal='getOrdersBack'
                  />
                </div>
              </td>
              <td style="width: 20rem" class="text-xs cursor-pointer font-weight-bolder mb-0 picko-link">
                <div class="d-flex">
                  <!-- <div class="my-auto form-check">
                    <input :id="item.id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item.id)" @change="changedSelection(item.id)" >
                  </div> -->
                  <a class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="goToDetalle(devolucion)">
                      <i
                          v-if="devolucion.sga_registered === false"
                          class="fa-solid fa-triangle-exclamation text-danger me-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-original-title="Not synced to SGA yet"
                      ></i>
                      {{ devolucion.number }}
                    </a>
                  </a>
                </div>
              </td>
              <!-- <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ devolucion.reference }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYY(devolucion.date) }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="devolucion.status == 'CANCELADO'" class="badge badge-cancelled badge-sm">{{ $t('key_filters_returnStatus_cancelled') }}</span>
                <span v-else-if="devolucion.status == 'FINALIZADO'" class="badge badge-located badge-sm">{{ $t('key_filters_returnStatus_finished') }}</span>
                <span v-else-if="devolucion.status == 'EN_PROCESO'" class="badge badge-processing badge-sm">{{ $t('key_filters_returnStatus_informed') }}</span>
                <span v-else-if="devolucion.status == 'REGISTRADO'" class="badge badge-saved badge-sm">{{ $t('key_filters_status_registered') }}</span>
                <span v-else-if="devolucion.status == 'RETENIDO'" class="badge badge-onhold badge-sm">{{ $t('key_orderStatus_onhold') }}</span>
                <span v-else class="badge badge-danger badge-sm" :title="devolucion.errors">{{ $t('key_filters_status_not_registered') }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ devolucion.end_customer.name }}</span>
              </td>
              <!-- <td class="font-weight-bold">
                <span v-if="devolucion.with_paid" class="badge badge-success badge-sm">{{ $t('key_orderBackList_orderBackRefunded') }}</span>
                <span v-else class="badge badge-warning badge-sm">{{ $t('key_orderBackList_orderBackRefundPending') }}</span>
              </td> -->
              <td class="font-weight-bolder">
                <span class="my-2 text-xs columns">{{ formatReturnedDate(devolucion.paid_date) }}</span>
              </td>
              <td class="units text-xs font-weight-bold">
                <ul>
                  <li><span class="my-2 text-xs text-info">{{ $t('key_returnList_informed') }}: {{ $numberFormat.toDecimalFormat(devolucion.units.requested) }}</span></li>
                  <li><span class="my-2 text-xs text-success">{{ $t('key_returnList_located') }}: {{ $numberFormat.toDecimalFormat(devolucion.units.completed) }}</span></li>
                </ul>
              </td>
              <!-- <td class="text-xs font-weight-bold">
                <span v-if="devolucion.batch_control" class="badge badge-info badge-sm">{{ $t('key_returnList_batchControl') }}</span>
              </td>
              <td class="text-xs font-weight-bold">
                <span v-if="devolucion.batch_control_date" class="badge badge-info badge-sm">{{ $t('key_returnList_batchControlDate') }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYYHH(devolucion.created_at) }}</span>
              </td>
              <td class="text-xs font-weight-bold">
                <a
                  style="cursor:pointer"
                  class="mx-3"
                  :title="devolucion.with_paid ? $t('key_orderBackList_orderBackRefunded') : $t('key_orderBackList_orderBackRefundPending')"
                  data-bs-toggle="modal"
                  data-bs-target="#paidModal"
                  @click="paymentModalData = { ...devolucion }">
                  <i :class="{ 'fa-solid fa-handshake text-warning': !devolucion.with_paid, 'fa-solid fa-money-bill-1-wave text-primary': devolucion.with_paid }"></i>
                </a>
                <a v-show="devolucion.status == 'REGISTRADO' || devolucion.status == 'RETENIDO'"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="devolucion.on_hold ? $t('key_return_returnAvailable') : $t('key_return_returnOnHold')"
                  data-bs-toggle="modal"
                  data-bs-target="#onHoldModal"
                  @click="onHoldModalData = { ...devolucion }">
                  <i :class="{ 'fa-solid fa-pause text-warning': !devolucion.on_hold, 'fa-solid fa-play text-primary': devolucion.on_hold }"></i>
                </a>
                <a v-show="devolucion.status == 'NO_REGISTRADO' || devolucion.status == 'REGISTRADO' || devolucion.status == 'RETENIDO'"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="$t('key_returnList_cancelReturn')"
                  data-bs-toggle="modal"
                  data-bs-target="#cancelEntityModal"
                  @click="() => entityId = devolucion._id">
                  <i class="fa-solid fa-times text-danger"></i>
                </a>
                <a v-show="devolucion.status == 'CANCELADO'"
                  style="cursor:pointer"
                  class="mx-3 icon-danger"
                  :title="$t('key_returnList_recoverReturn')"
                  data-bs-toggle="modal"
                  data-bs-target="#recoverEntityModal"
                  @click="() => entityId = devolucion._id">
                  <i class="fa-solid fa-arrow-rotate-left text-info"></i>
                </a>
              </td>
            </template>
          </GenericTable>

        </div>
      </div>
    </div>
  </div>
  <ModalCancelConfirmation :entity-id='entityId' @cancel-entity="cancelEntity" />
  <ModalRecoverConfirmation :entity-id='entityId' @recover-entity="recoverEntity" />
  <ModalOnHold :on-hold-modal-data='onHoldModalData' @confirm-on-hold-status="confirmOnHoldStatus" />
  <ModalPaid :payment-modal-data='paymentModalData' @make-payment="makePayment" />
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>

  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import ModalCancelConfirmation from "@/components/ModalCancelConfirmation.vue";
  import ModalRecoverConfirmation from "@/components/ModalRecoverConfirmation.vue";
  import ModalOnHold from "@/components/ModalOnHold.vue";
  import ModalPaid from "@/components/ModalPaid.vue";
  import { HkBtnUploadModal, FileModalSelector } from "@/hotaka/components";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import Filter from "./components/Filter.vue";
  import FilterAbonado from "./components/FilterAbonado.vue";
  import FilterDate from "../../components/FilterDate.vue";
  import Cookies from 'js-cookie';
  import SgaRegisteredFilter from "@/components/SgaRegisteredFilter.vue";
  import setTooltip from "@/assets/js/tooltip.js";

  export default {
    name: "DevolucionesList",
    components: {
      SgaRegisteredFilter,
      SoftButton,
      HkBtnUploadModal,
      SoftSnackbar,
      Filter,
      FileModalSelector,
      ModalPaid,
      ModalCancelConfirmation,
      ModalRecoverConfirmation,
      ModalOnHold,
      FilterDate,
      FilterAbonado,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        filterAbonadoSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        formatsFile:[
          { label: 'Sevica V2',value: 'SEVICA_V2'},
          { label: 'Sevica',value: 'SEVICA'},        
        ],
        urlUpload:"/order_back/batch",
        urlUploadResource: "order_back",
        entityId: null,
        entityNumber: null,
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        isLoading: false,
        showNotification: false,
        filters:{
          search: '',
          status:'',
          noPaid: false,
          paid: false,
          sort:{
            sort:'',
            order:''
          },
          date: {
            start: '',
            end: ''
          },
          sga_registered: '',
        },
        paymentModalData: {},
        onHoldModalData: {}
      };
    },
    computed: {
      devolucionesData() {
        return this.$store.state.ordersBackList.list.data;
      },
      ordersBackExcel() {
        return this.$store.state.ordersBackList.ordersBackExcel.data;
      },
      ordersBackResource() {
        return this.$store.state.ordersBackList.orderBackResource.data;
      },
      ordersBackErrorResource() {
        return this.$store.state.ordersBackList.orderBackResource.error;
      },
      payOrRevert() {
        return this.$store.state.ordersBackList.payOrRevert.status;
      },
      cancel() {
        return this.$store.state.ordersBackList.cancelEntity.status;
      },
      recover() {
        return this.$store.state.ordersBackList.recoverEntity.status;
      },
      onHoldStatus() {
        return this.$store.state.ordersBackList.onHoldStatus.status;
      },
      listFilters() {
        return this.$store.state.ordersBackList.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_ReturnList_files'), sort: { sorteable: true, order: '' }, column: "with_resource" },
          { title: this.$t('key_theader_ReturnList_number'), sort: { sorteable: true, order: '' }, column: 'number' },
          /* { title: this.$t('key_theader_ReturnList_reference'), sort: { sorteable: true, order: '' }, column: 'reference' }, */
          { title: this.$t('key_theader_ReturnList_entryDate'), sort: { sorteable: true, order: '' }, column: 'date' },
          { title: this.$t('key_theader_ReturnList_status'), sort: { sorteable: true, order: '' }, column: 'status' },
          { title: this.$t('key_theader_ReturnList_end_customer'), sort: { sorteable: true, order: '' }, column: 'end_customer' },
          /* { title: this.$t('key_theader_ReturnList_refunded'), sort: { sorteable: true, order: '' }, column: 'with_paid' }, */
          { title: this.$t('key_theader_ReturnList_refunded_date'), sort: { sorteable: true, order: '' }, column: 'paid_date' },
          { title: this.$t('key_theader_ReturnList_units'), sort: { sorteable: true, order: '' }, column: 'units' },
          /* { title: this.$t('key_theader_ReturnList_batch_control'), sort: { sorteable: true, order: '' }, column: 'batch_control' },
          { title: this.$t('key_theader_ReturnList_batch_control_date'), sort: { sorteable: true, order: '' }, column: 'batch_control_date' }, */
          { title: this.$t('key_theader_ReturnList_created_on'), sort: { sorteable: true, order: '' }, column: 'created_at' },
          { title: this.$t('key_theader_ReturnList_actions'), sort: { sorteable: false, order: ''}, }
        ]
      },
      title() {
        return this.$t('key_returnList_table_title');
      },
      description() {
        return this.$t('key_returnList_table_description');
      }
    },
    watch: {
      cancel(val) {
        if (val.canceled) {
          if (this.$store.state.ordersBackList.cancelEntity.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_return_cancelled'),
              message: this.$t('key_mmessage_return_cancelled'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrdersBack();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      recover(val) {
        if (val.recovered) {
          if (this.$store.state.ordersBackList.recoverEntity.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_return_recovered'),
              message: this.$t('key_mmessage_return_recovered'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrdersBack();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      onHoldStatus(val) {
        if (val.onHoldStatus) {
          if (this.$store.state.ordersBackList.onHoldStatus.data) {
            this.notificationInfo = {
              title: this.onHoldModalData.on_hold ? this.$t('key_mheader_return_available') : this.$t('key_mheader_return_on_hold'),
              message: this.onHoldModalData.on_hold ? this.$t('key_mmessage_return_available') : this.$t('key_mmessage_return_on_hold'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrdersBack();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      payOrRevert(val) {
        if (val.created) {
          if (this.$store.state.ordersBackList.payOrRevert.data) {
            this.notificationInfo = {
              title: this.paymentModalData.with_paid ? this.$t('key_mheader_return_notRefunded') : this.$t('key_mheader_return_refunded'),
              message: this.paymentModalData.with_paid ? this.$t('key_mmessage_return_notRefunded') : this.$t('key_mmessage_return_refunded'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrdersBack();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      devolucionesData() {
        if(this.devolucionesData){
          this.pagination.total= this.devolucionesData.total;
          this.isLoading = false;
          this.$nextTick(() => {
            setTooltip(this.$store.state.bootstrap);
          });
        }
      },
      ordersBackExcel() {
        if (this.$store.state.ordersBackList.ordersBackExcel.error ) {
          const error = this.$store.state.ordersBackList.ordersBackExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo = {
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification = true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else{
          this.downloadExcel(this.ordersBackExcel);
          return;
        }
      },
    },
    mounted() {
      this.setUpFilters()
      if (Object.keys(this.$route.query).length > 0) {
        this.filterStatusSelected = this.$route.query.status
        this.filters.status = this.$route.query.status;
      }
      this.getOrdersBack();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          this.defaultRangeDate()
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      defaultRangeDate(){
        const fecha = new Date();
    
        const from90 = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()-90
        );
        const today= new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()
        );
        
        this.filters.date.start=this.$dateUtils.toFormat(from90, 'yyyy-MM-DD');
        this.filters.date.end= this.$dateUtils.toFormat(today,'yyyy-MM-DD');
      },
      cancelEntity(entityId){
        this.$store.commit("ordersBackList/cancel", entityId);
      },
      recoverEntity(entityId){
        this.$store.commit("ordersBackList/recover", entityId);
      },
      makePayment(data){
        this.$store.commit("ordersBackList/payOrRevert", data);
      },
      uploadedResource(upload){
        if (upload['type'] == 'img') {
          this.$store.commit("ordersBackList/appendImage", upload['entity']);
          return
        }
        this.$store.commit("ordersBackList/appendDocument", upload['entity']);
      },
      removeResource(contract){
        if (contract['type'] == 'img') {
          this.$store.commit("ordersBackList/removeImage", contract['entity']);
          return
        }
        this.$store.commit("ordersBackList/removeDocument", contract['entity']);
      },
      loadResource(entity){
        this.entityId = entity._id
        this.entityNumber = entity.number
        this.$store.commit("ordersBackList/resetResources");
        this.$store.commit("ordersBackList/loadResource", entity._id);
      },
      getOrdersBack(){
        if (this.isLoading) return;

        this.isLoading = true
        this.$store.commit("ordersBackList/load",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      formatReturnedDate(date) {
        if (date && date !='') {
          return this.$dateUtils.toDDMMYYYY(date);
        }
        return '';
      },
      goToDetalle(element){
        this.$router.push({ path: "/Operations/Ordersback/OrderbackDetail/" + element._id});
      },
      importSuccess(){
        this.notificationInfo = {
          title: this.$t('key_mheader_order_imported'),
          message: this.$t('key_mmessage_order_imported'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getOrdersBack();
        }, 3000)
      },
      importFailure(status){
        this.notificationInfo = {
          title: 'Ups! Error',
          message: status.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      },
      closeNotification(){
        const self= this;
        setTimeout(function () {
          self.showNotification = false
        },2700);
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getOrdersBack(); 
      },
      onFilterChange(value){
        this.$router.replace({'query': {}})
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getOrdersBack(); 
      },
      onFilterAbonadoChange(value){
        this.$router.replace({'query': {}})
        this.filterAbonadoSelected = value
        if (value == 'paid') {
          this.filters.noPaid = false;
          this.filters.paid = true;
        } else if (value == 'noPaid') {
          this.filters.paid = false;
          this.filters.noPaid = true;
        } else if (value == '') {
          this.filters.paid = false;
          this.filters.noPaid = false;
        }
        this.getOrdersBack(); 
      },
      onDateFilterChange(value){
        this.filters.date.start= value.start
        this.filters.date.end= value.end
        this.getOrdersBack(); 
      },
      onFilterSgaRegisteredChange(value) {
        this.filters.sga_registered = value;
        this.getOrdersBack();
      },

      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getOrdersBack(); 
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getOrdersBack(); 
      },
      onDownloadExcel(){
        let savedLanguage = Cookies.get('Picko.language') || 'en';
        this.$store.commit("ordersBackList/ordersBackExcel", {filters: this.filters, language: savedLanguage});
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        link.setAttribute('download', `Returns-${formattedDate}`);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(link.href);
        }, 100);
      },  
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getOrdersBack(); 
      },
      onCleanFilterDate(){
        this.defaultRangeDate();
        this.getOrdersBack();
      },
      formatAbonadoDate(val){
        if (val && val !='' ){
          return this.$dateUtils.toDDMMYYYY(val);
        }
        return '';
      },
      confirmOnHoldStatus(data){
        this.$store.commit("ordersBackList/onHoldStatus", data);
      }
    }
  };

</script>

<style scoped>

  .units ul {
    list-style-type: none;
    padding: 0rem;
    margin-bottom: 0rem;
  }

  .columns {
    max-width: 150px;
  }

</style>
